export enum StorageEnum {
  LoginResponse = 'LoginResponse',
  MultiAccountResponse = 'MultiAccountResponse',
  GlobalVars = 'GlobalVariables',
  AccountDetail = 'AccountDetail',
  PaymentMethods = 'PaymentMethods',
  SuccessData = 'SuccessData',
  ErrorData = 'ErrorData',
  ChangeAutoPayData = 'ChangeAutoPayData',
  SelectedSA = 'SelectedSA',
  UserPW = 'UserPW',
  UserName = 'UserName',
  MultiState = 'MultiState',
  ClosedRouteVisited = 'ClosedRouteVisited',
  SeasonalRouteVisited = 'SeasonalRouteVisited',
  AccountLookUp = 'AccountLookUp',
  SSMData = 'SSMData',
  DeepLink = 'DeepLink',
  DigitalPaymentReturnRoute = 'DigitalPaymentReturnRoute',
  isProcess = 'isProcess',
  EncryptedCreds = 'EncryptedCreds',
  BioRedirectRoute = 'BioRedirectRoute',
  BioLockout = 'BioLockout',
  BioModalShown = 'BioModalShown',
  PasswordUpdatedNeedsBioUpdate = 'PasswordUpdatedNeedsBioUpdate',
  NotificationPermissionDenied = 'NotificationPermissionDenied',
  NotificationPermissionAsked = 'NotificationPermissionAsked',
  NotificationTokenValue = 'NotificationTokenValue',
  RememberedUsername = 'RememberedUsername',
  UpdateRequired = 'UpdateRequired',
  SystemStatusDown = 'SystemStatusDown',
  AccountSummaryBannerDismissed = 'AccountSummaryBannerDismissed',
}
